<app-header id="headerHeight"></app-header>
<app-toolbar id="toolbarheight"></app-toolbar>
<ngx-ui-loader></ngx-ui-loader>
<router-outlet></router-outlet>
<app-footer id="footerheight" class="footer-bottom"></app-footer>
<!-- *ngIf="!hideFooter"  -->